//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import Hashids from "hashids";

export default {
    name: "LitigationOverview",
    data() {
        return {
            userId: null,
            authorize_id: null,
            authorize_view: false,
            authorize_add: false,
            authorize_edit: false,
            authorize_del: false,

            search: "",
            page: 1,
            pageCount: 1,
            itemsPerPage: 10,
            itemsPerPageOptions: [5, 10, 25, 50, 100],
            filter: {
                court: null,
                caseType: null,
                caseStatus: null,
                invoiceStatus: null,
            },

            // ----- stat cards -----
            // stats: [
            //     { value: "128", label: "คดีทั้งหมด", cls: "s1" },
            //     { value: "43", label: "กำลังดำเนินการ", cls: "s2" },
            //     { value: "17", label: "รอออก Invoice", cls: "s3" },
            //     { value: "฿2.4M", label: "ชำระแล้ว (เดือนนี้)", cls: "s4" },
            //     { value: "6", label: "มีนัดภายใน 7 วัน", cls: "s5" },
            // ],

            // ----- filter options -----
            courtFilterList: [],
            caseTypeFilterList: [],
            caseStatusFilterList: [],
            invoiceFilterList: [],

            // ----- table headers -----
            headers: [
                { text: "รหัสคดี", value: "caseNo", sortable: true },
                { text: "โจทก์ / จำเลย", value: "parties", sortable: false },
                { text: "ศาล", value: "court", sortable: true },
                { text: "เลขดำ / แดง", value: "caseNumbers", sortable: false },
                { text: "นัดถัดไป", value: "nextHearing", sortable: false },
                { text: "สถานะคดี", value: "caseStatus", sortable: true },
                { text: "เลขที่ใบเสนอราคา", value: "soid", sortable: true },
                { text: "Price", value: "price", sortable: true },
                { text: "เลขที่ Invoice", value: "invoiceNo", sortable: true },
                { text: "สถานะ Invoice", value: "invoiceStatus", sortable: true },
                { text: "Action", value: "action", sortable: false, align: "center" },
            ],
            activeCard: null,
            // ----- table data (mock จาก wireframe — เปลี่ยนเป็น API จริงภายหลัง) -----
            items: [],
        };
    },
    watch: {
        search() {
            this.page = 1;
        },
    },
    computed: {
        filteredItems() {
            const kw = (this.search || "").trim().toLowerCase();

            return this.items.filter((item) => {
                const searchOk =
                    !kw ||
                    [item.caseNo, item.plaintiff, item.defendant, item.blackNo, item.redNo]
                        .some((f) => (f || "").toString().toLowerCase().includes(kw));

                // ----- กรองตามการ์ดที่กด -----
                let cardOk = true;
                if (this.activeCard === "progress") {
                    cardOk = item.caseStatus !== "ปิดคดี";
                } else if (this.activeCard === "wait_inv") {
                    cardOk = item.invoiceStatus === "Not Invoice";
                } else if (this.activeCard === "urgent") {
                    cardOk = this.isWithinDays(item.nextHearingDateRaw, 7);
                }
                // "all" หรือ null = ไม่กรอง

                const courtOk =
                    !this.filter.court || this.filter.court.includes("ทั้งหมด") || item.court === this.filter.court;
                const caseTypeOk =
                    !this.filter.caseType || this.filter.caseType.includes("ทั้งหมด") || item.caseType === this.filter.caseType;
                const caseStatusOk =
                    !this.filter.caseStatus || this.filter.caseStatus.includes("ทั้งหมด") || item.caseStatus === this.filter.caseStatus;
                const invoiceOk =
                    !this.filter.invoiceStatus || this.filter.invoiceStatus.includes("ทั้งหมด") || item.invoiceStatus === this.filter.invoiceStatus;

                return searchOk && cardOk && courtOk && caseTypeOk && caseStatusOk && invoiceOk;
            });
        },
        stats() {
            const items = this.items;
            const total = items.length;
            const inProgress = items.filter((i) => i.caseStatus !== "ปิดคดี").length;
            const waitInvoice = items.filter((i) => i.invoiceStatus === "Not Invoice").length;
            const within7 = items.filter((i) => this.isWithinDays(i.nextHearingDateRaw, 7)).length;

            return [
                { key: "all", value: total, label: "คดีทั้งหมด", cls: "s1" },
                { key: "progress", value: inProgress, label: "กำลังดำเนินการ", cls: "s2" },
                { key: "wait_inv", value: waitInvoice, label: "รอออก Invoice", cls: "s3" },
                { key: "urgent", value: within7, label: "มีนัดภายใน 7 วัน", cls: "s5" },
            ];
        },
    },

    async beforeCreate() {
        this.$store.state.navMenu = true;
    },

    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            // ----------------- Check Authorize ID ---------------------------
            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            // ----------------- Resolve Current Route Path -------------------
            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            // ----------------- Fetch Authorization --------------------------
            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            // ----------------- Check Login Status ---------------------------
            if (this.userId && api.isLoggedIn()) {
                // already logged in
                await this.loaddataLitigationCourt()
                await this.loaddataLitigationCourtCasetype()
                await this.loaddataLitigationCourtStatus()
                await this.loaddata()
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }


        } catch (error) {
            console.error("LitigationOverview mounted() error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        } finally {
            this.$hideLoader();
        }
    },

    methods: {
        async loaddataLitigationCourt() {
            try {
                const res = await api.dispute_resolution_getall_court();
                this.courtFilterList = [
                    { id: null, name: "ศาล: ทั้งหมด" },
                    ...(res.data || []),
                ];
            } catch (error) {
                console.error("loaddataLitigationCourt error:", error);
            }
        },

        async loaddataLitigationCourtCasetype() {
            try {
                const res = await api.dispute_resolution_getall_courttype();
                this.caseTypeFilterList = [
                    { id: null, name: "ประเภทคดี: ทั้งหมด" },
                    ...(res.data || []),
                ];

            } catch (error) {
                console.error("loaddataLitigationCourtCasetype error:", error);
            }
        },
        async loaddataLitigationCourtStatus() {
            const result = await api.getClientTimelineStatusCongFigByModule("Dispute Resolution");

            this.caseStatusFilterList = (result.data || []).map(item => ({
                ...item,
                module_id: Number(item.module_id)
            }));

        },
        setupAlertDialog(status, title, message, classText) {
            this.$store.state.global_dialog_message = {
                status: status,
                title: title,
                message: message,
                class: classText,
            };
        },

        // เช็คว่า dateStr อยู่ในช่วง [วันนี้, วันนี้+days] ไหม (เลยมาแล้วไม่นับ)
        isWithinDays(dateStr, days) {
            if (!dateStr) return false;
            const d = new Date(dateStr);
            if (isNaN(d)) return false;

            // ตัดเวลาออก เทียบเฉพาะวันที่
            d.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const limit = new Date(today);
            limit.setDate(limit.getDate() + days);

            return d >= today && d <= limit;
        },

        // เช็คว่าวันที่ที่ส่งมา ตรงกับวันนี้ไหม
        isSameDay(dateStr) {
            if (!dateStr) return false;
            const d = new Date(dateStr);
            if (isNaN(d)) return false;
            const now = new Date();
            return (
                d.getFullYear() === now.getFullYear() &&
                d.getMonth() === now.getMonth() &&
                d.getDate() === now.getDate()
            );
        },

        // แปลงเป็นรูปแบบไทยย่อ เช่น "18 มิ.ย. 69"
        formatThaiDate(dateStr) {
            if (!dateStr) return "";
            const d = new Date(dateStr);
            if (isNaN(d)) return dateStr;
            const months = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
                "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
            const day = d.getDate();
            const month = months[d.getMonth()];
            const yearBE = (d.getFullYear() + 543).toString().slice(-2);  // ปี พ.ศ. 2 หลักท้าย
            return `${day} ${month} ${yearBE}`;
        },
        formatNumber(n) {
            return Number(n).toLocaleString("th-TH");
        },
        onCardClick(key) {
            // กดการ์ดเดิมซ้ำ = ยกเลิก (toggle)
            if (this.activeCard === key) {
                this.activeCard = null;
                return;
            }
            this.activeCard = key;
            this.page = 1;
        },
        invoicePillClass(status) {
            switch (status) {
                case "Draft":
                    return "p-draft";
                case "Requested":
                    return "p-req";
                case "Invoiced":
                    return "p-inv";
                case "Paid":
                    return "p-paid";
                default:
                    return "p-draft";
            }
        },

        onNewCase() {
            this.$router.push("/dispute-resolution-docket/new");
        },

        prevPage() {
            if (this.page > 1) this.page--;
        },

        nextPage() {
            if (this.page < this.pageCount) this.page++;
        },

        onView(item) {
            var mainid = `${item.id}`;
            const hashids = new Hashids("my-secret-salt", 8);
            const encoded = hashids.encode(mainid);
            var encodedid = encoded;
            var module_name_send = "Dispute Resolution"
            const localUrl = window.location.origin;
            const text = `${localUrl}/client-view/case/${encodedid}?module_name=${encodeURIComponent(module_name_send)}`;
            window.open(text, "_blank");
        },

        onEdit(item) {
            this.$router.push(`/dispute-resolution-docket/${item.id || item.caseNo}`);
        },

        // ----- ตัวอย่าง method โหลดข้อมูลจริง -----
        async loaddata() {
            try {
                const res = await api.dispute_resolution_get_forDataTable(
                    Number(localStorage.getItem(server.COMPANYID))
                );
                console.log(res)
                const rows = Array.isArray(res.data) ? res.data : (res.data?.data || []);

                this.items = rows.map((r) => {
                    const hearingDate = r.next_hearing_date || "";   // ค่าดิบจาก API เช่น "2026-06-18"
                    const isToday = this.isSameDay(hearingDate);

                    let topic = r.next_hearing_topic || "";
                    if (isToday && topic) {
                        topic = "วันนี้ · " + topic;   // นัดวันนี้ → เติมข้อความนำหน้า
                    } else if (isToday) {
                        topic = "วันนี้";
                    }

                    return {
                        id: r.id,
                        caseNo: r.internal_case_no || "",
                        plaintiff: r.plaintiffs || "",
                        defendant: r.defendants || "",
                        court: r.court || "",
                        blackNo: r.black_no || "",
                        redNo: r.red_no || "",
                        caseStatus: r.case_status || "",
                        nextHearingDateRaw: hearingDate,
                        nextHearingDate: hearingDate ? this.formatThaiDate(hearingDate) : "",
                        nextHearingTopic: topic,
                        isUrgent: isToday,
                        price: r.soprice,
                        invoiceStatus: r.invoice_status,
                        invoiceNo: r.invoice_no,
                        soid: r.soid,
                        caseType: r.casename
                    };
                });
                // console.log(this.items)
            } catch (error) {
                console.error("loaddata error:", error);
                this.items = [];
            }
        },
    },
};
